export default __webpack_public_path__ + "static/media/bg-banner.ce6a4e1c.jpg";